import { useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { settingsDirectoryQuery } from '../api/settingsDirectory'
import { Spinner } from '../ui/Spinner'
import { settingsMoved, settingsUrl } from '../ui/Shell'
import './SettingsDirectoryPage.css'

/**
 * `/settings` - `settings/All_settings::index`, macheta
 * `settings/directory/index.php` si `directory/index-1.js`: toate ecranele de
 * setari, grupate, cu o casuta de filtrat deasupra. Filtrarea e in pagina, ca
 * acolo (vreo treizeci de randuri, toate deja aici); un grup din care n-a
 * ramas nimic se ascunde cu totul.
 *
 * Adresa fiecarui card trece prin `settingsUrl()`: ce e mutat in v4 duce sub
 * `/app`, ce n-a venit inca duce in portal - ca peste tot in schelet.
 */
export function SettingsDirectoryPage() {
  const page = useQuery(settingsDirectoryQuery)
  const [q, setQ] = useState('')
  const needle = q.trim().toLowerCase()

  const groups = useMemo(
    () =>
      (page.data?.groups ?? [])
        .map((group) => ({
          ...group,
          screens: group.screens.filter((s) => needle === '' || `${s.name} ${s.about} ${s.url}`.toLowerCase().includes(needle)),
        }))
        .filter((group) => group.screens.length > 0),
    [page.data, needle],
  )

  if (!page.data) return <Spinner />

  return (
    <div className="od-settings-dir">
      <header className="panel-heading">
        <h3>
          <strong>Settings</strong>
        </h3>
        <label className="color">
          Every settings screen in the portal, including the ones that are in no menu. {page.data.total} of them are open to you.
        </label>
      </header>
      <div className="od-sd-filter">
        <i className="fas fa-search" aria-hidden="true"></i>
        <input
          type="search"
          id="odSdFilter"
          className="form-control"
          placeholder="Filter by name or by what it does"
          autoComplete="off"
          autoFocus
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>
      {page.data.total === 0 ? (
        <div className="alert alert-info">
          <i className="fas fa-info-circle" aria-hidden="true"></i> You do not have access to any settings screen. Someone with administrator rights can grant it.
        </div>
      ) : (
        <>
          {groups.map((group) => (
            <section className="od-sd-group" key={group.name}>
              <h3 className="od-sd-group-name">{group.name}</h3>
              <div className="od-sd-cards">
                {group.screens.map((screen) => (
                  <a className="od-sd-card" key={screen.url + screen.name} href={settingsUrl(screen.url)} title={settingsMoved(screen.url) ? undefined : 'Opens in the classic portal'}>
                    <span className="od-sd-name">
                      {screen.name}
                      {screen.zone !== '' ? <span className="od-sd-zone">{screen.zone.charAt(0).toUpperCase() + screen.zone.slice(1)}</span> : null}
                    </span>
                    {screen.about.trim() !== '' ? <span className="od-sd-about">{screen.about}</span> : null}
                    <span className="od-sd-url">/{screen.url}</span>
                  </a>
                ))}
              </div>
            </section>
          ))}
          <p className="od-sd-none" hidden={groups.length > 0}>
            Nothing here matches what you typed.
          </p>
        </>
      )}
    </div>
  )
}
